import { SxProps, Theme, Typography, styled } from "@mui/material";
import { CSSProperties } from "react";

interface PageSubTitleProps {
  text?: string;
  color?: string;
  sx?: SxProps<Theme>;
  fontWeight?: CSSProperties["fontWeight"];
}

const PageSubTitle = ({ text, color, fontWeight, sx }: PageSubTitleProps) => {
  const PageSubTitleStyles = styled(Typography)(({ theme }) => ({
    color: color || theme.palette.app.primaryFont,
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: fontWeight || "400",
    lineHeight: "18px",
    whiteSpace: "pre-wrap",
  }));

  return <PageSubTitleStyles sx={sx}>{text}</PageSubTitleStyles>;
};

export default PageSubTitle;
